module.exports = __webpack_public_path__ + "static/img/xxtb4.ca411ca7.png";